/**
 * 分割带有换行符的文本
 * @description 用于处理带有换行符的文本，将其分割为数组
 * @param text
 * @returns
 */
export function splitText(text: string): string[] {
    return text.split(/\n|\\n/)
}
